import { Card, CardHeader } from '../../../../components/ui/Card';
import { TopDomainsPanel } from './shared/TopDomainsPanel';

export function SourcesGapPage() {
  return (
    <div className="space-y-4">
      <Card padding="md">
        <CardHeader
          title="Gap analysis"
          description="Domains that AI engines cite when answering — but never us. Each one is a place to win a citation."
        />
      </Card>
      <TopDomainsPanel limit={50} gap />
    </div>
  );
}
